import {
  ref,
} from '@vue/composition-api'

export const getCodeLabel = (codeType, code) => {
  const codeSet = constCodes.value[codeType]?.find(t => t.code === code)
  return codeSet ? codeSet.label : `예외 codeSetType (${code})`
}

export const getLabelCode = (codeType, label) => {
  const codeSet = constCodes.value[codeType]?.find(t => t.label === label)
  return codeSet ? codeSet.code : `예외 codeSetType (${label})`
}

export const constCodes = ref({
  conditionOr: [
    { label: 'OR', code: true },
    { label: 'AND', code: false },
  ],
  immediateOr: [
    { label: '즉시', code: true },
    { label: '선택', code: false },
  ],
  selectTimes: [
    { label: '10초', code: 10 },
    { label: '30초', code: 30 },
    { label: '1분', code: 60 },
    { label: '5분', code: 300 },
  ],
  // 진료 후 팝업 - 알림 시점 콤보 (12/11/13 시각으로 매핑, 99 = 직접지정)
  acpTimeRanges: [
    { label: '12~14시(기본)', code: 12 },
    { label: '11~13시', code: 11 },
    { label: '13~15시', code: 13 },
    { label: '직접지정', code: 99 },
  ],
  // 진료 후 팝업 - 시각 콤보 (01:00 ~ 24:00)
  acpHours: Array.from({ length: 24 }, (_, i) => ({
    label: `${String(i + 1).padStart(2, '0')}:00`,
    code: i + 1,
  })),
  // 진료 후 팝업 - 알림창 컬러
  acpColorTypes: [
    { label: 'Gray(기본)', code: 1 },
    { label: 'Blue', code: 2 },
  ],
  contentName: [
    { label: '약품정보', code: 1 },
    { label: '메디컬트렌드', code: 2 },
    { label: '설문조사', code: 3 },
    { label: 'WeeklyChoice', code: 4 },
    // { label: '웹세미나', code: 5 },
    { label: '웹 심포지엄', code: 5 },
    { label: '공지사항', code: 6 },
    { label: '이벤트', code: 7 },
    { label: '간편처방등록', code: 8 },
  ],
})
